<template>
	<div
		class="resource_list"
		:style="{ '--download-icon': 'url(' + downloadIcon + ')' }"
	>
		<div class="container">
			<div
				class="inner"
				:class="{ 'has-title': title != null }"
				:style="{
          '--padding-top': paddingTop,
          '--padding-bottom': paddingBottom
        }"
			>
				<transition name="fade">
					<div
						class="password_protected"
						v-if="password_protect === '1' && this.hideForm != true"
						:class="{ access_granted: this.passwordVerified === true }"
					>
						<form
							id="password_protec"
							@submit.prevent="verifyPassword"
						>
							<input
								type="password"
								ref="password"
								v-model="password"
								placeholder="Enter the password to proceed..."
							/>
							<!-- <input type="submit" value="Submit" /> -->

							<site-button-submit
								label="Submit"
								form="password_protec"
								value="submit"
							></site-button-submit>
						</form>

						<transition name="fade">
							<div
								v-if="this.passwordVerified === true"
								class="notification success"
							>
								<p>Access Granted.</p>
							</div>
						</transition>

						<transition name="fade">
							<div
								v-if="this.passwordVerified === false"
								class="notification error"
							>
								<p>Access Denied.</p>
							</div>
						</transition>

						<transition name="fade">
							<div
								v-if="
                  this.passwordVerified === false &&
                    this.$refs.password.value == false
                "
								class="notification warning"
							>
								<p>Please enter a password.</p>
							</div>
						</transition>
					</div>
				</transition>

				<transition-group name="fade">
					<template v-if="
              this.passwordVerified === true || this.password_protect === ''
            ">
						<div
							class="resource_section"
							v-for="(resource_section, index) in JSON.parse(resource_sections)"
							:key="index"
							:class="{'not-first': index > 0}"
						>
							<h3
								v-if="resource_section.title"
								v-html="resource_section.title"
							></h3>

							<div
								class="description"
								v-if="resource_section.description"
								v-html="resource_section.description"
							></div>

							<div class="resources">
								<a
									v-for="(resource, index) in resource_section.resources"
									:key="index"
									:href="resource.resource ? resource.resource.url : ''"
									:target="resource.resource? resource.resource.target : ''"
									class="resource"
								>
									<div class="icon_label">
										<div class="icon">
											<svg
												width="51"
												height="52"
												viewBox="0 0 51 52"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M21.864 22.3008C23.7669 20.415 26.3254 19.3761 29.0024 19.3822C31.6803 19.3883 34.236 20.4345 36.1316 22.3301L48.0482 34.2466C49.9492 36.1477 51 38.7111 51 41.3975C51 44.0836 49.9494 46.6471 48.0482 48.5481C46.1472 50.449 43.5838 51.5 40.8974 51.5C38.2111 51.5 35.6477 50.4493 33.7465 48.5483L21.3008 36.1023L23.6859 33.7173L36.1316 46.163C37.3992 47.4305 39.1069 48.1267 40.8974 48.1267C42.6877 48.1267 44.3956 47.4305 45.663 46.163C46.9304 44.8956 47.6267 43.1878 47.6267 41.3975C47.6267 39.6071 46.9305 37.8992 45.6631 36.6319L33.7465 24.7152C32.4834 23.4522 30.7841 22.7522 28.9991 22.7482C27.2134 22.744 25.5069 23.4323 24.2369 24.6909L23.7061 25.2167L21.3312 22.8287L21.864 22.3008Z"
													fill="#024FA8"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M29.1362 29.6996C27.2331 31.5854 24.6748 32.6241 21.9976 32.6181C19.3198 32.6119 16.7641 31.5657 14.8684 29.6701L2.9518 17.7537C1.05084 15.8525 0 13.2892 0 10.6029C0 7.91667 1.05078 5.35325 2.9518 3.45224C4.85287 1.55122 7.41633 0.500202 10.1027 0.500202C12.789 0.500202 15.3524 1.55094 17.2535 3.4521L29.6992 15.8979L27.3141 18.283L14.8684 5.83719C13.6009 4.5698 11.8931 3.8735 10.1027 3.8735C8.31218 3.8735 6.60448 4.5698 5.33703 5.83733C4.0696 7.10472 3.37327 8.81247 3.37327 10.6029C3.37327 12.3933 4.06949 14.101 5.33693 15.3684L17.2536 27.285C18.5166 28.548 20.2159 29.248 22.0011 29.2522C23.7867 29.2562 25.4932 28.568 26.7632 27.3096L27.2941 26.7835L29.6689 29.1717L29.1362 29.6996Z"
													fill="#024FA8"
												/>
											</svg>
										</div>
										<div class="label">
											<label v-html="resource ? resource.label : 'Resource'"></label>
										</div>
									</div>
									<label> Visit URL</label>
								</a>
							</div>
						</div>
					</template>
				</transition-group>
			</div>
		</div>
	</div>
</template>

<script>
import DownloadIcon from '../../images/download.svg';
import SiteButtonSubmit from '../vue/SiteButtonSubmit.vue';

export default {
	data() {
		return {
			downloadIcon: DownloadIcon,
			password: null,
			passwordVerified: null,
			loginAttempt: null,
			hideForm: null,
		};
	},

	props: {
		resource_sections: {},
		title: {
			default: null,
		},
		description: {
			default: null,
		},
		password_protect: {
			default: '',
		},
		paddingTop: {
			default: '80px',
		},
		paddingBottom: {
			default: '80px',
		},
	},

	computed: {
		parsedResources() {
			if(this.resource_sections) {
				return JSON.parse(this.resource_sections);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		sleep(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},

		async verifyPassword() {
			if (this.password === 'cpmecResources') {
				this.passwordVerified = true;
				await this.sleep(3000);
				this.hideForm = true;
			} else {
				this.passwordVerified = false;
				this.hideForm = false;
			}
		},
	},

	components: {
		SiteButtonSubmit,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.inner {
	padding: var(--padding-top) 0 var(--padding-bottom);

	@include until(tablet) {
		padding: $spacer;
	}

	.password_protected {
		display: grid;
		grid-template-columns:
			calc(100% / 3) calc((100% / 3) / 2) calc((100% / 3) / 2)
			calc(100% / 3);
		row-gap: $spacer;

		&.access_granted {
			margin-bottom: $spacer * 4;
		}

		form {
			display: grid;
			grid-template-rows: 1fr;
			gap: $spacer;
			grid-column: 2 / span 2;

			input {
				// width: calc(100% - (20px * 2));
				margin: 0;
				padding: 0 $spacer;
				appearance: none;
				border: 1px solid $cpmec-blue;
				background: $cpmec-white;
				min-height: 70px;
				grid-column: 1 / span 1;

				&:focus {
					outline: none;
					border: 1px solid $cpmec-green;
				}
			}

			button {
				grid-column: 2 / span 1;
				max-width: 100%;
			}
		}

		.notification {
			grid-column: span 4;
			display: grid;
			grid-template-columns:
				calc(100% / 3) calc((100% / 3) / 2) calc((100% / 3) / 2)
				calc(100% / 3);

			&.error {
				p {
					background: $cpmec-invalid;
					color: white;
				}
			}

			&.warning {
				p {
					border: 1px solid $cpmec-invalid;
					background: transparent;
					color: $cpmec-invalid;
				}
			}

			&.success {
				p {
					background: $cpmec-blue;
					color: white;
				}
			}

			p {
				grid-column: 2 / span 2;
				padding: $spacer;
				margin: 0;
			}
		}
	}

	h3 {
		font-family: $font-family;
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		letter-spacing: 0;
		color: $cpmec-blue;
		border-top: 1px solid $cpmec-blue;
		padding-top: $spacer * 2;
		grid-column: span 2;
		margin-top: 0;
		margin-bottom: $spacer * 2;
	}

	.description {
		margin: 0 0 $spacer * 2;
		color: $cpmec-grey;
	}

	.resource_section {
		&.not-first {
			margin-top: $spacer * 4;
		}
	}

	.resources {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: $spacer * 2;

		@media (max-width: $lg) {
			grid-template-columns: repeat(3, 1fr);
		}

		@include until(large-tablet) {
			grid-template-columns: repeat(2, 1fr);
			gap: $spacer * 1;
		}

		@include until(tablet) {
			grid-template-columns: repeat(1, 1fr);
		}

		.resource {
			display: flex;
			flex-direction: column;
			border: 1px solid $cpmec-blue;
			transition: 0.2s ease all;
			position: relative;
			text-decoration: none;

			&:hover {
				background-color: $cpmec-green;
				transition: 0.2s ease all;
				cursor: pointer;

				> label {
					transition: 0.2s ease all;
					background: $cpmec-green;
					// &::before {
					// 	margin-right: $spacer / 2;
					// 	opacity: 1;
					// }
				}
			}

			.icon_label {
				display: grid;
				grid-template-columns: 100px 1fr;
				column-gap: $spacer * 2;
				align-items: center;
				justify-content: center;
				padding: $spacer;
				border-bottom: 0 solid $cpmec-blue;

				.icon {
					display: flex;
					justify-content: center;
				}
			}

			> label {
				text-decoration: none;
				padding: $spacer;
				text-align: center;
				position: relative;
				background: #f4f4f4;
				transition: 0.2s ease all;

				&:hover {
					cursor: pointer;
				}

				// &::before {
				// 	content: var(--download-icon);
				// 	position: relative;
				// 	color: $cpmec-blue;
				// 	margin-right: 0;
				// 	transition: 0.2s ease all;
				// 	opacity: 0;
				// }
			}
		}
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-out 0.25s;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

@keyframes fade-out {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ResourceList.vue